<template>
  <el-dialog
    title="创建理货单"
    :visible.sync="visible"
    append-to-body
    width="1080px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :rules="rules"
      label-position="top"
      label-width="90px"
      :model="orderInfo">
      <el-form-item
        label="仓库:">
        {{ config.warehouseNo | warehouseName() }}
      </el-form-item>
      <el-form-item
        label="备注信息:"
        prop="remark">
        <el-input
          v-model="orderInfo.remark"
          :autosize="{ minRows: 2, maxRows: 4}"
          type="textarea"
          placeholder="请输入内容">
        </el-input>
      </el-form-item>
      <el-form-item
        label="选择发货单:">
        <el-table
          ref="table"
          v-loading="loading"
          max-height="720px"
          border
          :data="list"
          row-key="id"
          @selection-change="handleSelectionChange">
          <el-table-column
            fixed="left"
            type="selection"
            reserve-selection
            width="40">
          </el-table-column>
          <el-table-column
            label="发货单号"
            fixed="left"
            :resizable="false"
            width="200"
            prop="code">
            <template slot-scope="{row}">
              <div style="display:inline-block;">
                <div
                  v-for="(item,index) in row.code"
                  :key="index">{{ item }}</div>
              </div>
              <el-tag
                v-if="row.combinedDeliveryNumber > 0"
                type="warning">已并单</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="订单号"
            width="160"
            :resizable="false"
            prop="bizOrderCode">
            <template slot-scope="{row}">
              <div
                v-for="(item,index) in row.bizOrderCode"
                :key="index">{{ item }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="订单来源"
            width="90"
            :resizable="false">
            <template slot-scope="{row}">
              {{ row.orderSource | sourceName() }}
            </template>
          </el-table-column>
          <el-table-column
            label="收件人"
            min-width="140"
            prop="receiver">
          </el-table-column>
          <el-table-column
            label="出库类型"
            width="70"
            prop="type">
            <template slot-scope="{row}">
              {{ row.type| outTypeName() }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="发货方式"
            :resizable="false"
            width="120"
            prop="outType">
            <template slot="header">
              <el-select
                v-model="config.outType"
                size="mini"
                clearable=""
                placeholder="发货方式"
                @change="()=> {fetchList()}">
                <el-option
                  :key="2"
                  label="正常出库"
                  :value="0">
                </el-option>
                <el-option
                  :key="3"
                  label="空包出库"
                  :value="1">
                </el-option>
              </el-select>
            </template>
            <template slot-scope="{row}">
              {{ row.outType | orderOutTypeName() }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            label="打单状态"
            prop="printStatus"
            width="150">
            <template slot="header">
              <print-status-select
                v-model="config.printStatus"
                size="mini"
                style="width: 100%"
                :callback="()=> { fetchList() }" />
            </template>
            <template slot-scope="{row}">
              <span v-if="row.transType !== 3"> {{ row.printStatus | printStatusName() }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            :resizable="false"
            label="创建时间"
            width="140">
            <template slot-scope="{row}">
              {{ row.createTime | dateformat() }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>

</template>
<script>
// import PrintStatusSelect from '../../outstock/print-status-select.vue'

export default {
  name: 'OrderSelectModal',
  components: { },
  props: {
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      orderInfo: {
        remark: ''
      },
      rules: {
        remark: [
          { required: false, message: '请输入备注信息', trigger: 'blur' }
        ]
      },
      config: {
        pageNum: 1,
        pageSize: 1000000,
        code: '',
        status: 0,
        warehouseNo: ''
        // printStatus: null,
        // outType: null
      },
      list: [],
      multipleSelection: []
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.orderInfo.remark = ''
      this.config.warehouseNo = ''
      this.config.code = ''
      this.$refs.table && this.$refs.table.clearSelection()
      this.list = []
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/getoutlist', {
        payload: {
          ...this.config,
          ...this.option,
          createTally: 1,
          excludePrintTemplate: true
        },
        success: (res) => {
          this.loading = false
          if (res.data.data.records.length === 0) {
            this.$message.error('该仓库没有待理货的发货单')
            return
          }
          // this.list = res.data.data.records.map(i => {
          //   const sendOrder = i.sendOrderList[0]
          //   const { receiverName, receiverMobile, receiverTel, receiverProvince, receiverCity, receiverDistrict, receiverAddress } = sendOrder
          //   return {
          //     ...i,
          //     receiver: `${receiverName}-${receiverMobile}${receiverTel ? '-' + receiverTel : ''}-${receiverProvince}${receiverCity}${receiverDistrict}${receiverAddress}`
          //   }
          // })

          const newList = []
          const newMap = {}
          res.data.data.records.forEach(i => {
            const sendOrderList = i.sendOrderList || []
            const sendOrder = sendOrderList[0] || {}
            const { receiverName, receiverMobile, receiverTel, receiverProvince, receiverCity, receiverDistrict, receiverAddress } = sendOrder
            if (i.combinedDeliveryNumber === 0 || !i.combinedDeliveryNumber) {
              newList.push({
                ...i,
                code: [i.code],
                ids: [i.id],
                bizOrderCode: [i.bizOrderCode],
                receiver: `${receiverName}-${receiverMobile}${receiverTel ? '-' + receiverTel : ''}-${receiverProvince}${receiverCity}${receiverDistrict}${receiverAddress}`
              })
            } else {
              const itemMap = newMap[i.combinedDeliveryNumber]
              if (itemMap === undefined) {
                newList.push({
                  ...i,
                  code: [i.code],
                  ids: [i.id],
                  bizOrderCode: [i.bizOrderCode],
                  receiver: `${receiverName}-${receiverMobile}${receiverTel ? '-' + receiverTel : ''}-${receiverProvince}${receiverCity}${receiverDistrict}${receiverAddress}`
                })
                newMap[i.combinedDeliveryNumber] = newList.length - 1
              } else {
                const newListItem = newList[itemMap]
                newListItem.code.push(i.code)
                newListItem.ids.push(i.id)

                if (newListItem.bizOrderCode.indexOf(i.bizOrderCode) === -1) {
                  newListItem.bizOrderCode.push(i.bizOrderCode)
                }

                newList[itemMap] = newListItem
              }
            }
          })
          this.$set(this, 'list', newList.slice(0, 200)) // todo
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(warehouseNo) {
      this.config.warehouseNo = warehouseNo
      this.fetchList(() => {
        this.toggleModal(true)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.multipleSelection.length === 0) {
            this.$message.error('请至少选择一个出库单')
            return
          }
          this.loading = true
          this.$store.dispatch('outstock/tallyorderadd', {
            payload: {
              outOrderIdList: this.multipleSelection.reduce((prev, cur) => [...prev, ...cur.ids], []),
              warehouseNo: this.config.warehouseNo,
              remark: this.orderInfo.remark
            },
            success: () => {
              this.toggleModal(false)
              this.callback && this.callback()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
